module.exports = __webpack_public_path__ + "img/1F1FB-1F1FA.1477b0e2.svg";